import React, { useCallback } from "react";
import { Box } from "@mui/material";
import { detailsTabsBoxStyle } from "../../services/Utils";
import { getColumnsData } from "./VehiclesListInVehicleGroupColumns";
import OTAPagination from "../OTAPagination";
import { getVehiclesInGroup } from "../../services/deployment";

const VehiclesInGroupTab = (props) => {
  const { groupId } = props;

  const getVehiclesInGroupFn = useCallback(
    ({ queryKey }) => {
      const [, page, pageSize, field, sort, filterModel, columns] = queryKey;
      return getVehiclesInGroup({
        queryKey: [
          "vehiclesInGroup",
          page,
          pageSize,
          field,
          sort,
          groupId,
          "",
          false,
          filterModel,
          columns,
        ],
      });
    },
    [groupId],
  );

  return (
    <Box {...detailsTabsBoxStyle}>
      <OTAPagination
        columns={getColumnsData()}
        endpointFn={getVehiclesInGroupFn}
        queryName="vehiclesInGroup"
        filterMode="server"
        sortingMode="server"
        sortByDefault="serialNoCreatedAt"
        tableTitle="Vehicles"
        getRowId={(row) => row?.serialNo}
        sx={{ height: "calc(100vh - 290px)" }}
      />
    </Box>
  );
};

export default VehiclesInGroupTab;
